import React, { useContext } from "react";
import {
  Grid,
  makeStyles,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Button,
  Paper,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Context, ErrorLog } from "../store";          //FB 4487 DK - Importing ErrorLog class from store
//import { modify_SlotDetails } from "../actions";
import { modify_SlotDetails } from "../actions";
import globalsettings from "../../../config";
//FB-6264
//FB 7675
import { ConvertTimeZone, InsertPELogs, NotifyErrorOutage } from "../api";      //FB 4487 DK - Importing the logError method used for error logging , FB 4960

// update log
// FB 4371 DK    03/29/2021    Added UI component to display the slots
// FB 4409 DK    04/27/2021    Implementation of loading spinner on slots page
// FB 4487 DK    06/07/2021    Implemented error logging on api call failures
// FB 4556 DK    07/07/2021    Implement client side error handling on PE
// FB 4638 MS    08/31/2021    Fixed Mobile view issues
// FB 4735 DK    10/11/2021    Implementation of provider specific flow
// FB 4960 BR    07/03/2022    Logging all actions on PE
// FB 6264 DK    11/22/2022    Migrate PE API,DB to EMR
// FB 7675 DK    11/09/2023    Timezone handling for appointments
// FB 9742 SK    12/12/2024    No appointments showing up on PE

const useStyles = makeStyles(() => ({
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  container: {
    maxWidth: "10%",
    display: "flex",
    flexDirection: "column",
    alignSelf: "flex-start",
    justifyContent: "center",
  },
  containerRow: {
    //maxWidth: "10%",
    display: "flex",
    flexDirection: "row",
    alignSelf: "flex-start",
    justifyContent: "center",
  },
  topBarItem: {
    alignSelf: "flex-start",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  margin: {
    margin: "5px 0",
  },
  timeSlotItem: {
    borderRadius: "16px",
    border: "0",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EDEEEE",
    maxWidth: "70%",
    paddingRight: "5px",
    paddingLeft: "5px",
    cursor: "pointer",
    fontSize: "smaller",
    height: "25px",
    "&:hover, &:focus": {
      backgroundColor: "#25aae1",
      color: "#fff",
    },
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
  paper: {
    border: "0",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    alignContent: "center",
    display: "flex",
    boxShadow: "none",
    marginBottom: 10,
  },
  p: {
    backgroundColor: "#EDEEEE",
    padding: 5,
    borderRadius: "10px",
    fontSize: "smaller",
    "&:hover, &:focus": {
      backgroundColor: "#25aae1",
      color: "#fff",
    },
    margin: 0,
  },
}));

//FB 4371 DK    Added fnction to save the selected slot to preregistartion table
export async function addPreRegistration(preRegObj: any) {
  //FB-6264
  const targetUrl = globalsettings.emrAPI + "api/Provider/Schedule/Preregistration/AddSlot";
  const config = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    body: JSON.stringify(preRegObj),
  };
  const response = await fetch(targetUrl, config);

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  if (!response.ok) {
    //FB 4556 DK - Implement client side error handling on PE - Start
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    const data = await response.json();
    return data;
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

function SlotsContainer(props: any) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState<boolean>(false);
  const [itemsToShow, setItemsToShow] = React.useState<number>(6);
  const { state, dispatch } = useContext(Context);
  const [] = React.useState<boolean>(false);
  const [selectedSlot, setSelectedSlot] = React.useState<string>("");
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    modify_SlotDetails(
      {
        isslotexisting: true,
      },
      dispatch
    );
  };

  //FB 4371 DK    Added to toggle show more and hide slots

  function toggle() {
    setItemsToShow(expanded ? 6 : props.schedulesTest.Slots.length);
    setExpanded(!expanded);
    //FB 4960 Start
    if (expanded) {
      InsertPELogs(globalsettings.clientIp, "Click on Show less for " + props.schedulesTest.ScheduleDate);
    }
    else {
      InsertPELogs(globalsettings.clientIp, "Click on Show More for " + props.schedulesTest.ScheduleDate);
    }
    //FB 4960 End
  }
  const history = useHistory();

  //FB 4371 DK    Added to save the selected slot to preregistartion table and modify the state
  React.useEffect(() => {
    if (selectedSlot != "") {
      props.onCallback(true);
      //FB 4409 DK  Added to activate loading spinner once slot is selected
      props.isLoading(true);
      var date = new Date(
        props.schedulesTest.ScheduleDate + " " + selectedSlot
      );
      var x = date.getTimezoneOffset();
      date.setMinutes(date.getMinutes() - x);
      const preRegistrationObj = {
        EMPLOYEE_N: props.employeeid,
        FACILITY_N: props.facilityid,
        PRE_REGISTRATION_DATE: date,
        PRE_REGISTRATION_SLOT_TIME: date,
      };
      (async () => {
        var data = await addPreRegistration(preRegistrationObj);
        if (data == 0) {
          setOpen(true);
        } else {
          modify_SlotDetails(
            {
              employeeId: props.employeeid,
              facilityId: props.facilityid,
              id: data,
              slotDate: new Date(
                props.schedulesTest.ScheduleDate + " " + selectedSlot
              ),
              employeeName: props.employeeName,
              facilityName: props.facilityName,
              isslotexisting: false,
              duration: props.duration   //FB 4638 added appt duration
            },
            dispatch
          );
          //FB 4735 DK - Modified condition
          if (state.appointmentdetails.appointmentfilter === "provider" || state.defaultprovider.id > 0) {
            state.appointmentdetails.location.name = props.facilityName;
            state.appointmentdetails.location.address = props.facilityAddress;
          }
          state.appointmentdetails.location.phone = props.facilityPhone;
          state.appointmentdetails.duration = props.duration; //FB 4638 added appt duration 
          history.push("/demographics", state);
        }
      })();
    }
  }, [selectedSlot]);

  //FB 4371 DK    Added to book the selected slot

  function bookSlot(
    slots: any) {
    setSelectedSlot(slots);
    //FB 4960 start
    InsertPELogs(globalsettings.clientIp, "Click on time slot " + slots);
    //FB 4960 End
  }

  //FB 7675
  var timeZone = "America/Port-au-Prince";
  var userTimeZone = sessionStorage.getItem("TimeZone");
  if (userTimeZone != null) {
    timeZone = userTimeZone;
  }

  return (
    <React.Fragment>
      <Dialog
        open={open}
        id="differentSlotDialog"
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Slot is already booked!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please select a different slot.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      {props.limited === 1 ? (
        <Grid
          container
          direction="row"
          alignContent="center"
          style={{ display: "flex", flexFlow: "nowrap" }}
        >
          {props.schedulesTest.Slots.map((slot: string, index: number) => {
            // FB 7675
            var convertedSlot = ConvertTimeZone(props.schedulesTest.ScheduleDate, slot, timeZone, "time");
            return (
              <Grid
                container
                className={`${classes.topBarItem} ${classes.margin}`}
                key={index}
              >
                <div
                  className={`${classes.flexRow} ${classes.timeSlotItem}`}
                  style={{ width: "70px", height: "30px" }}
                  onClick={() =>
                    bookSlot(
                      slot
                    )
                  }
                >
                  {/* FB 7675 */}
                  {convertedSlot}
                </div>
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <Grid item sm={2} md={2}>
          {/* FB 9742 Begin */}
          {props.schedulesTest.Slots && props.schedulesTest.Slots.filter((slot:any) => slot.trim() !== "").slice(0, itemsToShow).map((slot: string, index: number) => {
            // FB 7675
            var convertedSlot = ConvertTimeZone(props.schedulesTest.ScheduleDate, slot, timeZone, "time");
            return (
              <Paper className={classes.paper} key={index}>
                <p
                  className={classes.p}
                  onClick={() => bookSlot(slot)}
                >
                  {/* FB 7675 */}
                  {convertedSlot}
                </p>
              </Paper>
            );
          })}
          {/* FB 9742 End*/}

          {props.schedulesTest.Slots.length < 6 ||
            props.schedulesTest.Slots.length === 0 ? (
            <div></div>
          ) : (
            <Paper className={classes.paper}>
              <p
                className={classes.p}
                style={{ maxWidth: 60, textAlign: "center" }}
                onClick={toggle}
              >
                {expanded ? "Show Less" : "Show More"}
              </p>
            </Paper>
          )}
        </Grid>
      )}
    </React.Fragment>
  );
}

export default SlotsContainer;
